export { default } from "./SidebarRemovalZoneView";
